import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Box } from '@mui/material';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const ChartComponent = () => {
  // Sample data for the chart
  const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    datasets: [
      {
        label: 'My First Dataset',
        data: 0, // Example data (change to actual data)
        fill: false,
        borderColor: 'rgb(75, 192, 192)',
        tension: 0.1
      }
    ]
  };

  const options = {
    responsive: false, // Disable responsive resizing, as you're setting fixed dimensions
    maintainAspectRatio: false, // Disable aspect ratio maintenance for custom width and height
    scales: {
      y: {
        beginAtZero: true, 
        min: 0,           
        max: 1,           
        ticks: {
          stepSize: 0.10,
          display: true,
          padding: 2,
        },
        grid: {
          drawBorder: true,
          color: 'rgba(0, 0, 0, 0.1)',
          borderDash: [5, 5],
          lineWidth: 1,
        },
      },
      x: {
        grid: {
          drawOnChartArea: false,
        }
      }
    },
    plugins: {
      legend: {
        position: 'bottom',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
  };

  return (
    <>
      {/* <Box sx={{ width: '1565px', height: '200px' }}> */}
        <Line data={data} options={options} height={200} width={1565} />
      {/* </Box> */}
    </>
  );
};

export default ChartComponent;
